// IMAGES
import commentSentimentAIImage from "src/images/subscription/ecommerce-comment-sentiment-ai.png";
import couponsIntegrationImage from "src/images/subscription/ecommerce-coupons-integration.png";
import formsImage from "src/images/subscription/ecommerce-forms.png";
import influencerPaymentsImage from "src/images/subscription/ecommerce-influencer-payments.png";
import clientAccessToCampaignsImage from "src/images/subscription/ecommerce-client-access-to-campaigns.png";
import creatorContactsDatabaseImage from "src/images/subscription/ecommerce-creator-contacts-database.png";
import massMailingImage from "src/images/subscription/ecommerce-mass-mailing.png";
import dictionaryManagerImage from "src/images/subscription/ecommerce-dictionary-manager.png";
import whiteLabelImage from "src/images/subscription/ecommerce-white-label.png";
import apiAccessImage from "src/images/subscription/ecommerce-api-access.png";
import publishedContentExtensionImage from "src/images/subscription/ecommerce-published-content-extension.png";
import socialInsightsImage from "src/images/subscription/social-insights-dashboard.png";

// ICONS
import commentSentimentAIIcon from "src/images/subscription/icons/comment-sentiment-ai.svg";
import couponsIntegrationIcon from "src/images/subscription/icons/coupons-integration.svg";
import formsIcon from "src/images/subscription/icons/forms.svg";
import influencerPaymentsIcon from "src/images/subscription/icons/influencer-payments.svg";
import clientAccessToCampaignsIcon from "src/images/subscription/icons/client-access-to-campaigns.svg";
import creatorContactsDatabaseIcon from "src/images/subscription/icons/creator-contacts-database.svg";
import massMailingIcon from "src/images/subscription/icons/mass-mailing.svg";
import dictionaryManagerIcon from "src/images/subscription/icons/dictionary-manager.svg";
import publishedContentExtensionIcon from "src/images/subscription/icons/published-content-extension.svg";

import { SubscriptionEntitlements } from "../../subscriptionUtils";

const getSubscriptionEntitlementSettings = (
  context: SubscriptionEntitlements,
) => {
  switch (context) {
    case SubscriptionEntitlements.PublicationSentiments:
      return {
        translation: {
          id: "ws_comment_sentiment_ai",
          defaultMessage: "Comment Sentiment AI",
        },
        image: commentSentimentAIImage,
        icon: commentSentimentAIIcon,
        text: {
          id: "ws_comment_sentiment_ai_description",
          defaultMessage:
            "Elevate your social media insights and influencer marketing strategies with comment sentiments AI.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/comment-sentiment-ai",
      };

    case SubscriptionEntitlements.Forms:
      return {
        translation: {
          id: "ws_intelligent_forms",
          defaultMessage: "Intelligent Forms",
        },
        image: formsImage,
        icon: formsIcon,
        text: {
          id: "ws_intelligent_forms_description",
          defaultMessage:
            "Allows you to recruit new creators efficiently by gathering essential information in a customizable form.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/intelligent-forms",
      };

    case SubscriptionEntitlements.CouponsIntegration:
      return {
        translation: {
          id: "ws_e_commerce_coupons_integration",
          defaultMessage: "eCommerce Coupons Integration",
        },
        image: couponsIntegrationImage,
        icon: couponsIntegrationIcon,
        text: {
          id: "ws_ecommerce_coupons_integration_description",
          defaultMessage:
            "eCommerce integrations provide real-time sales/ROI data, helping you measure performance and refine campaigns.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/ecommerce-coupons-integration",
      };

    case SubscriptionEntitlements.WsXtrmExtension:
      return {
        translation: {
          id: "ws_influencer_payments",
          defaultMessage: "Influencer Payments",
        },
        image: influencerPaymentsImage,
        icon: influencerPaymentsIcon,
        text: {
          id: "ws_influencer_payments_description",
          defaultMessage:
            "Enables seamless, secure, and efficient payments to creators directly through the platform.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/influencer-payments",
      };

    case SubscriptionEntitlements.ClientMode:
      return {
        translation: {
          id: "ws_client_access_to_campaigns",
          defaultMessage: "Client Access to Campaigns",
        },
        icon: clientAccessToCampaignsIcon,
        image: clientAccessToCampaignsImage,
        text: {
          id: "ws_client_access_to_campaign_description",
          defaultMessage:
            "Manage what information is visible to your clients within the platform. Apply ‘client mode’ to hide sensitive information.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/client-access-to-campaigns",
      };

    case SubscriptionEntitlements.ContactDataVisibility:
      return {
        translation: {
          id: "ws_creator_contacts_database",
          defaultMessage: "Creator Contacts Database",
        },
        icon: creatorContactsDatabaseIcon,
        image: creatorContactsDatabaseImage,
        text: {
          id: "ws_creator_contacts_database_description",
          defaultMessage:
            "This feature grants access to a creator contacts database, simplifying outreach and collaboration.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/creator-contacts-database",
      };

    case SubscriptionEntitlements.WsMessengerExtension:
      return {
        translation: {
          id: "ws_mass_mailing",
          defaultMessage: "Mass mailing",
        },
        icon: massMailingIcon,
        image: massMailingImage,
        text: {
          id: "ws_mass_mailing_description",
          defaultMessage:
            "Email Multiple Creators at once and launch campaigns faster.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/mass-mailing",
      };

    case SubscriptionEntitlements.DictionaryManager:
      return {
        translation: {
          id: "ws_flex_menu_builder",
          defaultMessage: "Flex Menu Builder",
        },
        icon: dictionaryManagerIcon,
        image: dictionaryManagerImage,
        text: {
          id: "ws_flex_menu_builder_description",
          defaultMessage:
            "The feature enables custom data organization and adapts the platform to unique business processes.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/flex-menu-builder",
      };

    case SubscriptionEntitlements.WhiteLabel:
      return {
        translation: {
          id: "ws_white_label_platform",
          defaultMessage: "White Label Platform",
        },
        // icon: dictionaryManagerIcon,
        image: whiteLabelImage,
        text: {
          id: "ws_white_label_platform_description",
          defaultMessage:
            "Enables full customization of the platform’s visual and functional elements (including the URL) to match your brand’s identity.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/white-label-platform",
      };

    case SubscriptionEntitlements.APIAccess:
      return {
        translation: {
          id: "ws_campaign_data_api",
          defaultMessage: "Campaign Data API",
        },
        // icon: dictionaryManagerIcon,
        image: apiAccessImage,
        text: {
          id: "ws_campaign_data_api_description",
          defaultMessage:
            "Syncs campaign data with Google Sheets via API, enabling seamless data management and in-depth analysis.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/campaign-data-api-google-worksheet",
      };
    case SubscriptionEntitlements.SocialInsights:
      return {
        translation: {
          id: "ws_social_insights",
          defaultMessage: "Social Insights",
        },
        image: socialInsightsImage,
        text: {
          id: "ws_social_insights_description",
          defaultMessage:
            "Track hashtags, mentions and competitors across platforms and markets to plan campaigns on real data.",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/1784633906-social-insights-overview",
      };

    case SubscriptionEntitlements.StorePublishedContentsExtension:
      return {
        translation: {
          id: "ws_store_published_contents",
          defaultMessage: "Store Published Contents",
        },
        image: publishedContentExtensionImage,
        icon: publishedContentExtensionIcon,
        text: {
          id: "ws_store_published_contents_text",
          defaultMessage: "Store published contents",
        },
        learnMoreUrl:
          "https://help.indahash.com/hc/workspace/articles/published-content-auto-collection",
      };
    default:
      return {
        translation: {
          id: "ws_subscription_feature",
          defaultMessage: "Subscription feature",
        },
        image: dictionaryManagerImage,
        icon: dictionaryManagerImage,
        text: {
          id: "ws_subscription_feature",
          defaultMessage: "Subscription feature",
        },
        learnMoreUrl: "https://help.indahash.com/hc/workspace/en",
      };
  }
};

export default getSubscriptionEntitlementSettings;
